import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Search model for Product barcode
 */
@Injectable()
export class ProductBarcodeSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "productBarcodeId";
    }

}
